import IconButton from '@mui/material/IconButton';
import { ArrowBack, Edit } from '@mui/icons-material';
import React, { Fragment } from 'react';

const Header = ({
  selectedForm,
  title,
  mode,
  onClickBack,
  onEditFormMetadata,
}) => {
  return (
    <div className="header">
      {selectedForm ? (
        <div className="header-row">
          <IconButton
            className="back-button circle-icon"
            aria-label="back arrow"
            component="span"
            title="Back to form table"
            color="primary"
            onClick={onClickBack}
          >
            <ArrowBack />
          </IconButton>
          <span className="title">{selectedForm.name}</span>
          {mode === 'builder' ? (
            <Fragment>
              <span className="dot fa fa-circle"></span>
              <span className="sub-title">{title}</span>
              <span className="dot fa fa-circle"></span>
              <IconButton
                className="edit-button circle-icon"
                aria-label="edit pencil"
                component="span"
                title="Edit Form Metdata"
                color="primary"
                onClick={onEditFormMetadata}
              >
                <Edit />
              </IconButton>
            </Fragment>
          ) : null}
        </div>
      ) : (
        <span className="title">{title}</span>
      )}
    </div>
  );
};

export default Header;
